var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5001 0.916016C7.45008 0.916016 0.916748 7.44935 0.916748 15.4993C0.916748 23.5493 7.45008 30.0827 15.5001 30.0827C23.5501 30.0827 30.0834 23.5493 30.0834 15.4993C30.0834 7.44935 23.5501 0.916016 15.5001 0.916016ZM22.7917 16.9577H16.9584V22.791H14.0417V16.9577H8.20841V14.041H14.0417V8.20768H16.9584V14.041H22.7917V16.9577Z",
    fill: "#FFFBFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5001 0.916016C7.45008 0.916016 0.916748 7.44935 0.916748 15.4993C0.916748 23.5493 7.45008 30.0827 15.5001 30.0827C23.5501 30.0827 30.0834 23.5493 30.0834 15.4993C30.0834 7.44935 23.5501 0.916016 15.5001 0.916016ZM22.7917 16.9577H16.9584V22.791H14.0417V16.9577H8.20841V14.041H14.0417V8.20768H16.9584V14.041H22.7917V16.9577Z",
    fill: "#13BAED",
    fillOpacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.447d7541983a3d07824c2b6ef89ec1b1.svg";
export { ForwardRef as ReactComponent };